import { AxiosResponse, AxiosError } from 'axios';
//
import apiService from 'services/api';
import apiRoutes from 'services/api/routes';
import { getAccessToken } from 'lib/auth';
import { getAxiosErrorMessage } from 'lib/helpers/error-handler';
import {
  ADD_MARKER_TO_FORMULA,
  CANCEL_FORMULA_EDIT,
  GET_MARKERS,
  GET_MARKERS_FAIL,
  GET_MARKERS_SUCCESS,
  START_FORMULA_EDIT,
  UPDATE_FIELD,
  UPDATE_MARKER_LIST_FORMULA,
  EFormulaModalType,
  IMarkerList,
} from 'store/formula-entry/types';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

interface IStartFormulaEditProps {
  descriptionInputValue: string;
  formulaInputValue: string;
  modalType: EFormulaModalType;
  productIndex: number;
}

export function startFormulaEdit({
  descriptionInputValue,
  formulaInputValue,
  modalType,
  productIndex,
}: IStartFormulaEditProps) {
  return {
    type: START_FORMULA_EDIT,
    descriptionInputValue,
    formulaInputValue,
    modalType,
    markerSearchInputValue: '',
    productIndex,
  };
}

export function cancelFormulaEdit() {
  return {
    type: CANCEL_FORMULA_EDIT,
  };
}

export function updateField(field: string, value: string) {
  return (dispatch: ThunkDispatch<void, void, AnyAction>) => {
    dispatch({
      type: UPDATE_FIELD,
      field,
      value,
    });
  };
}

export function addMarkerToFormula(marker: string) {
  return {
    type: ADD_MARKER_TO_FORMULA,
    marker,
  };
}

export function updateMarkerList(markerList: IMarkerList[]) {
  return {
    type: UPDATE_MARKER_LIST_FORMULA,
    markerList,
  };
}

export const getMarkers = () => (dispatch: ThunkDispatch<void, void, AnyAction>) =>
  new Promise<void>((resolve, reject) => {
    dispatch({
      type: GET_MARKERS,
    });

    apiService
      .get(apiRoutes.markers, {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      })
      .then(({ data }: AxiosResponse) => {
        dispatch({
          type: GET_MARKERS_SUCCESS,
          markers: data,
        });
        resolve();
      })
      .catch((error: AxiosError) => {
        const errorMessage = getAxiosErrorMessage(error);
        if (!error.message.includes('401')) {
          dispatch({
            type: GET_MARKERS_FAIL,
            error: errorMessage,
          });
        }
        reject(errorMessage);
      });
  });
